import React, { memo, useMemo } from 'react';
import { View } from 'react-native';
import { useAppSelector } from 'store/hooks';
import { Spacer } from 'design-system';
import SectionHeader from 'design-system/SectionHeader';
import { selectShouldShowAutosave } from '../reducers/selectors';
import AutomatedSavingsStatusCard from './AutomatedSavingsStatusCard';
import SetupAutomatedSavingsCard from './SetupAutomatedSavingsCard';
const AutomatedSavingsCard = ({ noMarginBottom }) => {
    const savingsPlanMode = useAppSelector((state) => state.pots.savingsPlanMode);
    const savingsPlanTierFees = useAppSelector((state) => state.pots.savingsPlanTierFees);
    const savingsPlanFrequency = useAppSelector((state) => state.pots.savingsPlanFrequency);
    const savingsPlanMandateStatus = useAppSelector((state) => state.pots.savingsPlan?.mandateStatus);
    const hasAutomatedSavings = useAppSelector(selectShouldShowAutosave);
    const Content = useMemo(() => {
        if (savingsPlanMandateStatus) {
            return <AutomatedSavingsStatusCard noMarginBottom={noMarginBottom}/>;
        }
        return <SetupAutomatedSavingsCard noMarginBottom={noMarginBottom}/>;
    }, [noMarginBottom, savingsPlanMandateStatus]);
    if (hasAutomatedSavings && savingsPlanMode && savingsPlanTierFees && savingsPlanFrequency) {
        return (<>
        <Spacer h={8}/>
        <SectionHeader horizontalMargins>Deposits on autopilot</SectionHeader>
        {Content}
      </>);
    }
    return <View testID="emptyView"/>;
};
export default memo(AutomatedSavingsCard);
